(function () {
    'use strict';
    var Constants = require('../constants/AppConstants');
    var _ = require('lodash');
    const { decodeJwt } = require("jose");

    var urlUtils = {
        getParameterByName: function (name, url, isRaw = false) {
            if (!url) url = window.location.href;
            //url = url.toLowerCase();
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return isRaw ? results[2].replace(/\+/g, " ") : decodeURIComponent(results[2].replace(/\+/g, " "));
        },


        isSamlFlow: function (url) {
            if (!url) url = window.location.href;
            if (url.toLowerCase().indexOf("/web/saml") != -1)
                return true;
            else
                return false;
        },
        
         fetchToken: function () {
            let url = window.location.href;
            let token = url.split('/').pop().split('?').shift();
            return token;
         },


        getHashParameterbyName: function (name, url) {
            if (!url) url = window.location.href;
            var query = url.split('#')[1];
            if (_.isEmpty(query)) return '';
            var paramsArray = (/^[?#]/.test(query) ? query.slice(1) : query)
                .split('&')
                .reduce((params, param) => {
                    let [key, value] = param.split('=');
                    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                    return params;
                }, {});
            return paramsArray[name] ? paramsArray[name] : '';
        },

        fetchTraceId: function () {
            var traceId = urlUtils.getParameterByName('DR-Trace-ID');
            if (!traceId)
                traceId = urlUtils.createTraceId()

            return traceId;
        },

        fetchEmailSentForgotPasswordInfo: function () {
            return urlUtils.getParameterByName('emailSent');
        },
        
        fetchChannelNotificationForgotPasswordInfo: function () {
            return urlUtils.getParameterByName('notificationChannel');
        },

        fetchClientIdInfo: function () {
            return urlUtils.getParameterByName('client_id');
        },

        fetchIdToken: function () {
            return urlUtils.getParameterByName('id_token');
        },

        fetchDecodedIdToken: function () {
            var idToken = urlUtils.getParameterByName('id_token');
            if(idToken)
            {
                return decodeJwt(urlUtils.getParameterByName('id_token'));
            }
            else return {}
        },

        fetchAccountIdInfo: function () {
            return urlUtils.getParameterByName('account_id');
        },

        fetchCountryCodeInfo: function () {
            return urlUtils.getParameterByName('country_code');
        },

        fetchUserType: function () {
            return urlUtils.getParameterByName('user_type');
        },
        fetchLoginId: function () {
            return urlUtils.getParameterByName('login_id');
        },
        fetchUserId: function () {
            return urlUtils.getParameterByName('user_id');
        },
        fetchGrantTypeInfo: function () {
            let response_type = urlUtils.getParameterByName('response_type');
            if (!response_type) return ""
            else return response_type;
        },
        fetchRealmIdInfo: function () {
            let realmId = urlUtils.getParameterByName('realm_id');
            var url = window.location.href.toLowerCase();
            if(!realmId && url.indexOf('/loginpreferences') != -1)
                realmId = 'IDAM_LPREALM';

            return realmId;
        },
        fetchRedirectURLInfo: function () {
            return urlUtils.getParameterByName('redirect_uri');
        },
        fetchRedirectRawURLInfo: function () {
            return urlUtils.getParameterByName('redirect_uri', null, true);
        },
        fetchLocaleIdInfo: function () {
            return urlUtils.getParameterByName('locale_id');
        },
        fetchStateInfo: function () {
            let state = urlUtils.getParameterByName('state');
            return state;
        },
        fetchScopeInfo: function () {
            let scope = urlUtils.getParameterByName('scope');
            return scope;
        },
        fetchPromptInfo: function () {
            return urlUtils.getParameterByName('prompt');
        },
        fetchNonceInfo: function () {
            let nonce = urlUtils.getParameterByName('nonce');
            return nonce;
        },
        fetchCodeChallengeInfo: function () {
            let codeChallenge = urlUtils.getParameterByName('code_challenge');
            return codeChallenge;
        },
        fetchCodeChallengeMethodInfo: function () {
            let codeChallengeMethod = urlUtils.getParameterByName('code_challenge_method');
            return codeChallengeMethod;
        },
        fetchSessionStateInfo: function () {
            let sessionState = urlUtils.getParameterByName('session_state');
            return sessionState;
        },
        fetchClientsToBeLogoutInfo: function () {
            let clientsToBeLogout = urlUtils.getParameterByName('logout_clientids');
            return clientsToBeLogout;
        },
        fetchPostLogoutRedirectUriInfo: function () {
            let postLogoutRedirectUri = urlUtils.getParameterByName('post_logout_redirect_uri');
            return postLogoutRedirectUri;
        },
        fetchToastrMessage: function () {
            let toastrMessage = urlUtils.getParameterByName('message');
            if (toastrMessage && !_.isEmpty(toastrMessage)) {
                toastrMessage = toastrMessage.split('?')[0];
                //remove ?status=Success from value of message as it looks for key accordingly
            }
            return toastrMessage;
        },
        fetchPreviewInfo: function () {
            return urlUtils.getParameterByName('preview');
        },
        fetchInitSessionIdInfo: function () {
            let initSessionId = urlUtils.getParameterByName('init_session_id');
            if (!initSessionId) return ""
            else return initSessionId;
        },
        fetchLoginMethodInfo: function () {
            let loginMethod =  urlUtils.getParameterByName('login_method');
            if (!loginMethod) return ""
            else return loginMethod;
        },

        fetchURLInfo: function () {
            URL = urlUtils.getParameterByName('url');
            if (URL != null) {

                var Base64 = {
                    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
                    encode: function (e) {
                        var t = "";
                        var n, r, i, s, o, u, a;
                        var f = 0;
                        e = Base64._utf8_encode(e);
                        while (f < e.length) {
                            n = e.charCodeAt(f++);
                            r = e.charCodeAt(f++);
                            i = e.charCodeAt(f++);
                            s = n >> 2;
                            o = (n & 3) << 4 | r >> 4;
                            u = (r & 15) << 2 | i >> 6;
                            a = i & 63;
                            if (isNaN(r)) {
                                u = a = 64
                            } else if (isNaN(i)) {
                                a = 64
                            }
                            t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
                        }
                        return t
                    },
                    decode: function (e) {
                        var t = "";
                        var n, r, i;
                        var s, o, u, a;
                        var f = 0;
                        e = e.replace(/[^A-Za-z0-9+/=]/g, "");
                        while (f < e.length) {
                            s = this._keyStr.indexOf(e.charAt(f++));
                            o = this._keyStr.indexOf(e.charAt(f++));
                            u = this._keyStr.indexOf(e.charAt(f++));
                            a = this._keyStr.indexOf(e.charAt(f++));
                            n = s << 2 | o >> 4;
                            r = (o & 15) << 4 | u >> 2;
                            i = (u & 3) << 6 | a;
                            t = t + String.fromCharCode(n);
                            if (u != 64) {
                                t = t + String.fromCharCode(r)
                            }
                            if (a != 64) {
                                t = t + String.fromCharCode(i)
                            }
                        }
                        t = Base64._utf8_decode(t);
                        return t
                    },
                    _utf8_encode: function (e) {
                        e = e.replace(/rn/g, "n");
                        var t = "";
                        for (var n = 0; n < e.length; n++) {
                            var r = e.charCodeAt(n);
                            if (r < 128) {
                                t += String.fromCharCode(r)
                            } else if (r > 127 && r < 2048) {
                                t += String.fromCharCode(r >> 6 | 192);
                                t += String.fromCharCode(r & 63 | 128)
                            } else {
                                t += String.fromCharCode(r >> 12 | 224);
                                t += String.fromCharCode(r >> 6 & 63 | 128);
                                t += String.fromCharCode(r & 63 | 128)
                            }
                        }
                        return t
                    },
                    _utf8_decode: function (e) {
                        var t = "";
                        var n = 0;
                        var r = 0;
                        var c1 = 0;
                        var c2 = 0;
                        while (n < e.length) {
                            r = e.charCodeAt(n);
                            if (r < 128) {
                                t += String.fromCharCode(r);
                                n++
                            } else if (r > 191 && r < 224) {
                                c2 = e.charCodeAt(n + 1);
                                t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                                n += 2
                            } else {
                                c2 = e.charCodeAt(n + 1);
                                c3 = e.charCodeAt(n + 2);
                                t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                                n += 3
                            }
                        }
                        return t
                    }
                }


                var string = URL;
                string = string.replace(/%0D%0A/g, "");
                var decodedString = Base64.decode(string);
                var result = {};
                decodedString.split('&').forEach(function (x) {
                    var arr = x.split('=');
                    arr[1] && (result[arr[0]] = arr[1]);
                });
                return result;

            }
        },

        delete_cookie: function (name) {
            var cookie = this.getCookie(name);
            if (cookie) {
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.' + window.location.host + ';path=/;';
            }
        },

        getCookie: function (name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        },

        saveCookie: function (name, value) {
            var expires = "";
            document.cookie = name + "=" + value + expires + "; path=/; secure;";
        },


        varyByCountry: function (url, countryCode) {
            if (!url) {
                return url;
            }
            let idx = url.indexOf(Constants.FooterPlaceHolders.COUNTRY_CODE);
            if (idx > -1) {
                let newUrl = url.substring(0, idx) + countryCode +
                    url.substring(idx + Constants.FooterPlaceHolders.COUNTRY_CODE.length, url.length);
                return newUrl;
            } else {
                return url;
            }
        },

        appendQueryParam(param, val) {
            if (val) {
                return '&' + param + '=' + val
            } else {
                return ""
            }
        },

        setQueryParameter(paramName, paramValue, url) {
            var hash = window.location.hash;
            url = url.replace(hash, '');
            if (url.indexOf(paramName + '=') >= 0) {
                var prefix = url.substring(0, url.indexOf(paramName));
                var suffix = url.substring(url.indexOf(paramName));
                suffix = suffix.substring(suffix.indexOf('=') + 1);
                suffix = (suffix.indexOf('&') >= 0) ?
                    suffix.substring(suffix.indexOf('&')) : '';
                url = prefix + paramName + '=' + paramValue + suffix;
            }
            else {
                if (url.indexOf('?') < 0)
                    url += '?' + paramName + '=' + paramValue;
                else
                    url += '&' + paramName + '=' + paramValue;
            }
            return (url + hash);
        },

        setHashParameter(paramName, paramValue, url) {
            var hash = window.location.hash;
            url = url.replace(hash, '');
            if (url.indexOf(paramName + '=') >= 0) {
                var prefix = url.substring(0, url.indexOf(paramName));
                var suffix = url.substring(url.indexOf(paramName));
                suffix = suffix.substring(suffix.indexOf('=') + 1);
                suffix = (suffix.indexOf('&') >= 0) ?
                    suffix.substring(suffix.indexOf('&')) : '';
                url = prefix + paramName + '=' + paramValue + suffix;
            }
            else {
                if (url.indexOf('#') < 0)
                    url += '#' + paramName + '=' + paramValue;
                else
                    url += '&' + paramName + '=' + paramValue;
            }
            return (url + hash);
        },

        removeEmptyParams(url) {
            return url.replace(/[^=&]+=(&|$)/g, '').replace(/&$/, '');
        },

        createTraceId() {
            var dt = new Date().getTime();
            var traceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (dt + Math.random() * 16) % 16 | 0;
                dt = Math.floor(dt / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return traceId;
        },

        formatCustCompLinks(object, redirectUrl) {
            for(var key in object){
                if(object.hasOwnProperty(key)){
                     var value = object[key];
                     object[key] = !_.isEmpty(value) && urlUtils.getParameterByName("postlogonurl", value) == "{redirect_uri}" 
                                        && urlUtils.setQueryParameter("postlogonurl", redirectUrl, value) 
                                        || value;
                  }
           }
           return object;
        },

        formForgotPwdLinkUrl(props, localeId) {
            var forgotPasswordUrl = window.location.protocol + "//" + window.location.host + Constants.Links.FORGOTPASSWORD_URL + 
                    Constants.UrlParams.CLIENT_ID + "=" + props.clientId + 
                    this.appendQueryParam(Constants.UrlParams.REALM_ID, props.realmId) + 
                    this.appendQueryParam(Constants.UrlParams.USER_TYPE, props.userType) + 
                    this.appendQueryParam(Constants.UrlParams.REDIRECT_URI, encodeURIComponent(props.redirectUrl)) + 
                    this.appendQueryParam(Constants.UrlParams.RESPONSE_TYPE, props.responseType) + 
                    this.appendQueryParam(Constants.UrlParams.LOCALE_ID, localeId) + 
                    this.appendQueryParam(Constants.UrlParams.SCOPE, props.scope) + 
                    this.appendQueryParam(Constants.UrlParams.NONCE, props.nonce) + 
                    this.appendQueryParam(Constants.UrlParams.COUNTRY_CODE, props.countryCode) + 
                    this.appendQueryParam(Constants.UrlParams.STATE, props.state) + 
                    this.appendQueryParam(Constants.UrlParams.ACCOUNT_ID, props.accountId) + 
                    this.appendQueryParam(Constants.UrlParams.TRACE_ID, props.traceId) + 
                    this.appendQueryParam(Constants.UrlParams.PREVIEW, props.preview) + 
                    this.appendQueryParam(Constants.UrlParams.CODE_CHALLENGE, props.codeChallenge) + 
                    this.appendQueryParam(Constants.UrlParams.CODE_CHALLENGE_METHOD, props.codeChallengeMethod);

            return forgotPasswordUrl;        
        },

    }
    module.exports = urlUtils;

}());
